<template>
    <transition type="animation" enter-active-class="animate__animated animate__fadeIn" mode="out-in" appear>
        <div v-if="temPermissao('p-super-admin')">
            <b-card no-body class="shadow-none border-0" header-bg-variant="white">
                <template #header>
                    <h5>Menu de Escolas</h5>
                </template>
                <b-nav class="p-3">
                    <b-nav-item small class="btn-simple" @click="navigateTo('listaEscola')">
                        <span>
                            <i class="fa-light fa-clipboard-list-check fa-lg mr-1"></i>
                            Lista Escolas
                        </span>
                    </b-nav-item>
                    <b-nav-item small class="btn-simple" @click="navigateTo('cadastrarEscolaSuperPro')">
                        <span>
                            <i class="fa-light fa-school fa-lg mr-1"></i>
                            Cadastrar Escola
                        </span>
                    </b-nav-item>
                    <b-nav-item small class="btn-simple" @click="navigateTo('estornarCreditoEscolaSuperPro')" disabled>
                        <span>
                            <i class="fa-light fa-money-check-dollar-pen fa-lg mr-1"></i>
                            Estornar Crédito - Escola
                        </span>
                    </b-nav-item>
                </b-nav>
            </b-card>
            <b-card no-body class="pt-3 border-bottom-0 border-left-0 border-right-0">
                <div class="p-3" v-if="!showContent">
                    <h4 class="text-center">Clique e escolha o tipo de administração e sua subcategoria!</h4>
                </div>
                <div class="p-3" v-else>
                    <router-view></router-view>
                </div>
            </b-card>
        </div>
    </transition>
</template>
<script>
export default {
    name: 'schools-superpro',
    data() {
        return {
            usuario: false,
        }
    },
    computed: {
        permissions() {
            return this.$store.state.auth.userpermissions.permissions;
        },
        error503() {
            return (window.location.href = '/nao-autorizado');
        },
        showContent() {
            const currentPath = this.$route.path;
            const validPath = [
                '/admin-super-pro/schools-superpro/lista-escolas',
                '/admin-super-pro/schools-superpro/cadastrar-escola',
                '/admin-super-pro/schools-superpro/estornar-credito-escola',
            ];
            return validPath.includes(currentPath);
        },
    },
    methods: {
        temPermissao(permissao) {
            return this.permissions.includes(permissao);
        },
        navigateTo(routeName) {
            if (this.$route.path !== routeName) {
                this.$router.push({ name: routeName });
            } else {
                console.error('Estamos com problemas');
            }
        },
    },
    watch: {
        $route(to) {
            if (!this.showContent) {
                this.usuario = false;
            }
        },
    },

}
</script>
<style lang="scss" scoped>
.btn-simple {
    span {
        color: #333333;
    }

    &:hover {
        color: #333333;
        background-color: #eff5ff;
        border-radius: 5px;
    }
}

.active-link {
    color: #333333;
    background-color: #e2e7f5 !important;
    text-decoration: none;
    // padding: 8px 16px;
    border-radius: 5px;
    text-align: center;

    &:hover {
        background-color: #e2e7f5;
    }
}
</style>